import '../../globals';


/**
 * Category list
 * As they are floating and may contain long titles plus seo text:
 */
(function(PageLoadedQueue) {
    const setSubcategoryHeights = () => {
        $('.category-page-content .subcategory').equalHeights('reset').equalHeights();
    }

    const resetSubcategoryHeights = () => {
        $('.category-page-content .subcategory').equalHeights('reset');
    }

    document.addEventListener('plandent.subcategories.setHeights', setSubcategoryHeights, {passive: true});
    document.addEventListener('plandent.subcategories.resetHeights', resetSubcategoryHeights, {passive: true});
})(window.PageLoadedQueue);
